<template>
    <div id="listContainer">
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
            </div>
        </div>


        <Table 
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
            @cellDblClick="cellDblClick"
        >
            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'order_channel_type'">
                    <a-tag :color="props.record.order_channel_type_val == 0? 'blue' : 'pinkpurple' ">{{ props.record.order_channel_type }}</a-tag>
                </div>
                <div v-if="props.column.key == 'courier_status'">
                    <a-tag :color="courierStatusColor[props.record.courier_status_val]">{{ props.record.courier_status }}</a-tag>
                </div>
            </template>

            <template v-slot:tableOperate="{ props }">
                <a-button v-permission="'setting.stock.edit'"  type="primary" size="mini" :disabled="props.record.status_val == 3 || props.record.courier_status_val === 0" style="margin-top:5px;width:92px" @click="handle('download',props.record)">{{ $t('invoice.download') }}</a-button>
            </template>
        </Table>

    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick } from 'vue';
    import { InvoiceApi } from '@/api/InvoiceApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { InvoiceOrdreListQuery } from './queryConfig/InvoiceListQuery.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { dateToTimestamp, timestampToDate } from '@/utils/index.js';

    const { t } = useI18n()
    const localeStore = useLocale()

    const props = defineProps({
        visible:{
            type:Boolean,
            default:false,
        }
    })

    const visible = ref(false)
    const operateType = ref('add')
    const rowData = ref()
    const queryForm = reactive(InvoiceOrdreListQuery)
    const orderSource = reactive({})
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'center',
            },
            {
                // title: '订单号',
                title: t('invoice.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'120',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '订单来源',
                title:t('order.orderSource'),
                dataIndex: 'source',
                key:'source',
                width:'120',
                // align:'center',
            },
            {
                // title: '订单渠道类型',
                title: t('order.orderChannelType'),
                dataIndex: 'order_channel_type',
                key:'order_channel_type',
                width:'120',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            {
                // title: '发货状态',
                title:t('order.deliverStatus'),
                dataIndex: 'courier_status',
                key:'courier_status',
                width:'150',
                // align:'center',
                slotName: 'slot'
            },
            {
                // title: '订单类型',
                title:t('order.orderType'),
                dataIndex: 'order_type',
                key:'order_type',
                width:'120',
                // align:'center',
            }, 
            {
                // title: '创建日期',
                title:t('order.orderDate'),
                dataIndex: 'order_date',
                key:'order_date',
                width:'120',
                // align:'center',
            },
            {
                title: '操作',
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'100',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                x:1200,
                y:540,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
            
        },
    })

    const courierStatus = ref({ // 发货状态
        0:t('order.unship'),
        1:t('order.plan'),
        2:t('order.partialShip'),
        3:t('order.shiped'),
        4:t('order.signedFor'),
        5:t('order.cancel'),
        7:t('order.partialReturn'),
        8:t('order.return'),
        9:t('order.exchange'),
        10:t('order.partialExchange'),
        99:t('order.noNeedToShip'),
    })

    const courierStatusColor = ref({ // 发货状态
        0:'magenta',
        1:'blue',
        2:'orange',
        3:'lime',
        4:'green',
        5:'#86909c', // 已取消
        7:'#ea7ccc', // 部分退货
        8:'#f71ebb', // 退回
        9:'#6e74e0', // 换货
        10:'#afb2f5', // 部分换货
        99:'#333', // 无需发货
    })


    const handle = (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getOrderList()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    queryForm.formData[item.key] = ''
                })
                table.value.configs.pagination.current = 1
                getOrderList()
                break;
            case 'download':
                validIsExistInvoice(row)
                break;
        }
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getOrderList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getOrderList()
    }

    const handleSelectChange = (val,opt,key)=>{
        console.log(val,opt,key)
        let item = queryForm.formField.find(i=> i.key == 'courier_status')
        if(key == 'order_channel_type'){
            item.disabled = val == 4
            queryForm.formData.courier_status = val == 4? 99 : 3
        }

        table.value.configs.pagination.current = 1
        getOrderList()
    }

    const handleInputClear = (val,item)=>{
        table.value.configs.pagination.current = 1
        getOrderList()
    }

    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getOrderList()
    }

    // 获取订单列表
    const getOrderList = async ()=>{
        let param = {
            ...queryForm.formData,
            order_name:queryForm.formData.order_name.trim(),
            // order_channel_type:0,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await InvoiceApi.getInstance().getOrderList(param, page_num, page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.length > 0 && res.data.records.forEach((item,index)=>{
                table.value.datas.push({
                    ...item,
                    No: index + 1,
                    source_val: item.source,
                    source: orderSource[item.source],
                    order_channel_type_val:item.order_channel_type,
                    order_channel_type: item.order_channel_type === 0? t('order.user') : t('order.service'),
                    order_type_val: item.order_type,
                    order_type: item.order_type == undefined? '-' : item.order_type == 0? t('order.sale') : t('order.unSale'),
                    courier_status_val:item.courier_status,
                    courier_status: courierStatus.value[item.courier_status],
                    order_date:timestampToDate(item.order_timestamp * 1000)
                })
            })
            table.value.configs.pagination.total = res.data.total
            table.value.configs.pagination.current = res.data.current
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 判断发票是否存在
    const validIsExistInvoice = async(row)=>{
        let res = await InvoiceApi.getInstance().validIsExistInvoice(row.id, 1, '')
        if(res.code == 0){
            if(res.data.length == 0){
                validDownloadInvoice(row)
            }else{
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:true,
                    content:  t('invoice.doubleInvoiceMsg'),
                    okText:t('base.ok'),
                    onOk:()=>{}
                })
            }
        }else{
            Message.error(res.msg)
        }
    }

    // 检验是否可以下载发票
    const validDownloadInvoice = async(row)=>{
        let res = await InvoiceApi.getInstance().validDownloadInvoice(row.id, '')
        if(res.code == 0){
            downloadInvoice(row)
        }else{
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                hideCancel:true,
                content:  res.msg,
                okText:t('base.ok'),
                onOk:()=>{}
            })
        }
    }

    // 下载发票
    const downloadInvoice = async (row)=>{
        let param = {
            order_number: row.order_name,
            invoice_type: 1,
        }
        table.value.configs.loading = true
        let res = await InvoiceApi.getInstance().downloadInvoice(param)
        if(!res.code){
            let blob = new Blob([res],{type: 'application/octet-stream'})
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${row.order_name}.pdf`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            setTimeout(()=>{
                table.value.configs.loading = false
                Message.success(t('base.downloadSuccess'))
            },1500) 
        }else{
            Message.error(res.msg)
            table.value.configs.loading = false
        }
    }

    // 获取订单来源类型 和 erp客户编码
    const getOrderSource = async ()=>{
        let res = await OrderApi.getInstance().getOrderSource({status:'A'})
        if(res.code == 0){
            res.data.length > 0 && res.data.forEach(i=>{
                orderSource[i.id] = i.id == 1? 'Shopify' : i.customer_name
            })

            console.log(orderSource.value,'orderSource.value')
        }else{
            Message.error(res.msg)
        }
    }

    watch(()=>props.visible,(val)=>{
        if(val){
            queryForm.formData.courier_status = 3
            getOrderList()
        } 
    })


    onMounted(()=>{
        getOrderSource()
        getOrderList()

        queryForm.formField.forEach(i=>{
            if(i.key == 'order_channel_type'){
                queryForm.formData.order_channel_type = 0
            }
        })
    })

</script>

<style lang="less" scoped>

.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}


/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 10px 0;
    font-weight: 600;
}

/deep/ .arco-table-container{
    padding-bottom: 0;
}

/deep/ .arco-table-td{
    padding: 10px 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}


.addForm{
    /deep/ .arco-input-wrapper,
    /deep/ .arco-picker-size-medium{
        height: 45px;
    }

    /deep/ .arco-form-item-label-col{
        line-height: 45px;
    }
}

</style>